export const FETCH_SINGLE_SEO_PAGE = 'FETCH_SINGLE_SEO_PAGE';
export const CREATE_SINGLE_SEO_PAGE = 'CREATE_SINGLE_SEO_PAGE';
export const UPDATE_SINGLE_SEO_PAGE = 'UPDATE_SINGLE_SEO_PAGE';